export class UserDetailedListItem {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    applicationRoleName: string;
    applicationRole: number;
    lastUpdated: Date;
    lastUpdatedBy: string;
    dateOfDeactivation: Date;
    status: string;
}